import { useCallback } from "react";
import { useAppDispatch } from "../../../redux/hooks";
import {
  linkyConsentsSlice,
  sendDriverOnboardingLinkAsync,
} from "./linkyConsentsSlice";

const RESEND_LINK_COOLDOWN_MS = 30_000;

export const useSendDriverOnboardingLink = () => {
  const dispatch = useAppDispatch();

  return useCallback(
    (driverUuid: string) => {
      setTimeout(
        () =>
          dispatch(
            linkyConsentsSlice.actions.endOnboardingLinkCooldown(driverUuid),
          ),
        RESEND_LINK_COOLDOWN_MS,
      );
      void dispatch(sendDriverOnboardingLinkAsync(driverUuid));
    },
    [dispatch],
  );
};
